"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
const react_1 = __importStar(require("react"));
const noop_1 = __importDefault(require("lodash/noop"));
const classnames_1 = __importDefault(require("classnames"));
const useMergeRefs_1 = __importDefault(require("../../hooks/useMergeRefs"));
const bem_helper_1 = require("../../helpers/bem-helper");
const useKeyboardButtonPressedFunc_1 = require("../../hooks/useKeyboardButtonPressedFunc");
const test_utils_1 = require("../../utils/test-utils");
require("./Clickable.scss");
const CSS_BASE_CLASS = "monday-style-clickable";
const bemHelper = (0, bem_helper_1.BEMClass)(CSS_BASE_CLASS);
const Clickable = (0, react_1.forwardRef)(({ elementType = "div", className = "", id, children, role = "button", onClick = noop_1.default, enableTextSelection = false, onMouseDown = noop_1.default, ariaLabel, ariaHidden, ariaHasPopup, ariaExpanded, tabIndex = "0", disabled = false, style, dataTestId }, ref) => {
    const componentRef = (0, react_1.useRef)(null);
    const mergedRef = (0, useMergeRefs_1.default)({ refs: [ref, componentRef] });
    const onKeyDown = (0, useKeyboardButtonPressedFunc_1.useKeyboardButtonPressedFunc)(onClick);
    return react_1.default.createElement(elementType, {
        ref: mergedRef,
        className: (0, classnames_1.default)(CSS_BASE_CLASS, className, {
            disabled,
            [bemHelper({ state: "disable-text-selection" })]: !enableTextSelection
        }),
        "data-testid": dataTestId || (0, test_utils_1.getTestId)(test_utils_1.ELEMENT_TYPES.CLICKABLE, id),
        role: role,
        onClick: disabled ? undefined : onClick,
        id: id,
        onKeyDown: disabled ? undefined : onKeyDown,
        tabIndex: disabled ? -1 : tabIndex,
        "aria-label": ariaLabel,
        "aria-hidden": ariaHidden,
        "aria-haspopup": ariaHasPopup,
        "aria-expanded": ariaExpanded,
        onMouseDown: onMouseDown,
        style: style
    }, children);
});
exports.default = Clickable;
